module.exports = __webpack_public_path__ + "img/validations-filters.ad62249b.jpg";